import { config } from "../config";
export function checkIdExists(targetId, localId) {
  if (config.documentExperimentalFeature) return true;
  const ids = targetId.split(",").map((id) => id.trim());
  return ids.includes(localId);
}
